export default function anonymous(props
) {
var out='<div class="'+(props.styles.container)+'" data-playable-component> <div class="'+(props.styles.frame)+'" data-playable-hook="preview-full-size-frame" > </div></div>';return out;
}